/*
 * @Description: 申请服务费 store
 * @Author: lijinpeng
 * @Date: 2023-04-01 14:20:30
 * @LastEditTime: 2023-09-19 14:50:47
 * @LastEditors: WangYuhan
 */
// 引入api请求方法
import {
  applyServiceFeeBillListExport,
  getApplyServiceFeeBillList,
  getApplyServiceFeeBillListCount,
} from '@/api/invoice';

const storeModuleName = 'serviceFeeApplyModule';
const state = {
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'input',
      param: 'id',
      value: '',
      valueType: 'string',
      label: '申请ID',
      placeholder: '请输入',
      clearable: true,
    },
    {
      style: 'date-picker',
      param: 'applyTime',
      value: [],
      valueType: 'date',
      label: '申请时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['strApplyTime', 'endApplyTime'],
    },
    {
      style: 'date-picker',
      param: 'month',
      value: '',
      valueType: 'date',
      label: '月份',
      placeholder: '请选择',
      type: 'month',
      format: 'yyyy-MM',
      valueFormat: 'yyyy-MM',
      clearable: true,
    },
  ],
  // 特殊筛选项目 带统计信息
  // 按钮筛选项
  isSpecialButton: [
    {
      title: '发票状态',
      name: 'status',
      value: '',
      selectList: [
        {
          value: 'ALL',
          label: '全部',
          isActive: true,
          count: 0,
          countName: 'totalCount',
        },
        {
          value: 'TO_INVOICE',
          label: '待开票',
          isActive: false,
          count: 0,
          countName: 'toInvoiceCount',
        },
        {
          value: 'VERIFY_ING',
          label: '审核中',
          isActive: false,
          count: 0,
          countName: 'verifyingCount',
        },
        {
          value: 'INVOICE',
          label: '已开票',
          isActive: false,
          count: 0,
          countName: 'invoiceCount',
        },
        {
          value: 'VERIFY_REJECT',
          label: '审核不通过',
          isActive: false,
          count: 0,
          countName: 'verifyRejectCount',
        },
      ],
    },
  ],
  // 配置是否导出
  isExport: {
    isShow: true,
    url: applyServiceFeeBillListExport,
  },
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '申请ID',
        prop: 'invoiceId',
        width: 90,
        sortable: true,
        checked: 1,
      },
      {
        label: '企业名称',
        prop: 'businessName',
        width: 100,
        sortable: true,
        checked: 1,
      },
      {
        label: '账单月份',
        prop: 'month',
        width: 80,
        sortable: true,
        checked: 1,
      },
      {
        label: '账单金额',
        prop: 'serviceFee',
        width: 80,
        sortable: true,
        checked: 1,
        slotName: 'sub-domain-serviceFee',
      },
      {
        label: '可开票金额',
        prop: 'amount',
        width: 80,
        sortable: true,
        checked: 1,
        slotName: 'sub-domain-amount',
      },
      {
        label: '申请状态',
        prop: 'status',
        width: 80,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-status',
      },
      {
        label: '审核不通过原因',
        prop: 'rejectMsg',
        width: 120,
        sortable: true,
        checked: 1,
      },
      {
        label: '审核时间',
        prop: 'approvalTime',
        width: 80,
        sortable: true,
        checked: 1,
      },
      {
        label: '快递单号',
        prop: 'fastmailOrderNo',
        width: 100,
        sortable: true,
        checked: 1,
      },
      {
        label: '申请人',
        prop: 'applyName',
        width: 70,
        sortable: true,
        checked: 1,
      },
      {
        label: '申请备注',
        prop: 'applyRemark',
        width: 80,
        sortable: true,
        checked: 1,
      },
      {
        label: '申请时间',
        prop: 'applyTime',
        width: 80,
        sortable: true,
        checked: 1,
      },
      {
        label: '操作',
        prop: '',
        width: 100,
        sortable: true,
        checked: 1,
        slotName: 'sub-domain-button',
      },
    ],
  },
  invoicingStatus: [], // 支付状态统计
  companyList: [], // 企业列表
  companyInfo: '', // 当前选中的企业信息
  statisticsTxt: '',
  reports: {},
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        if (item.type === 'month') {
          params[item.param] = item.value;
        } else {
          params[item.params[0]] = `${item.value[0]} 00:00:00`;
          params[item.params[1]] = `${item.value[1]} 23:59:59`;
        }
      }
    });
    context.state.isSpecialButton.forEach(item => {
      if (item.value) params[item.name] = item.value;
    });
    var serviceFeeApplyListHabits = {};
    const obj = Object.assign({}, context.state.postParams);
    if (obj.businessId || params.businessId) {
      serviceFeeApplyListHabits.businessId = obj.businessId ? obj.businessId : params.businessId;
    }
    localStorage.setItem('serviceFeeApplyListHabits', JSON.stringify(serviceFeeApplyListHabits));

    // 获取统计信息
    const { code, data } = await getApplyServiceFeeBillList(params);
    if (data && data.records) {
      context.commit('updateState', {
        key: 'listData',
        value: Object.assign({}, context.state.listData, {
          list: data.records,
        }),
      });
    }
    await context.dispatch('getStatistics');
    await context.dispatch('getStatisticsPage', params);
  },
  // 获取状态统计数据
  getStatistics: async context => {
    const { data } = await getApplyServiceFeeBillListCount({
      businessId: context.state.parameters[0].value,
    });
    context.state.isSpecialButton[0].selectList.forEach((selectItem, index) => {
      context.commit('updateButtonValueFromIndex', {
        index,
        value: data[selectItem.countName],
      });
    });
  },
  // 获取状态统计数据
  getStatisticsPage: async (context, params) => {
    const { data } = await getApplyServiceFeeBillListCount(params);
    context.commit('updateState', {
      key: 'reports',
      value: data,
    });
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
};

// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
    state.isSpecialButton.forEach(item => {
      item.selectList.forEach((select, selectIndex) => {
        select.isActive = selectIndex === 0;
      });
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        if (payload.from !== 1) {
          localStorage.removeItem('serviceFeeApplyListHabits');
          localStorage.setItem(
            'serviceFeeApplyListHabits',
            JSON.stringify({
              businessId: payload.value,
            }),
          );
        }
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        break;
      default:
        break;
    }
  },
  // 根据index&value更新按钮状态
  updateSpecialStatusFromIndex(state, payload) {
    // 要修改的按钮组
    const specialData = state.isSpecialButton[payload.index];
    // 按钮组是否支持多选
    if (payload.value === 'ALL') {
      specialData.value = '';
    } else {
      specialData.value = payload.value;
    }
    specialData.selectList.forEach(item => {
      item.isActive = item.value === payload.value;
    });
  },
  // 更新按钮统计数据
  updateButtonValueFromIndex(state, payload) {
    state.isSpecialButton[0].selectList[payload.index].count = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
